<template>
  <BaseTableView v-if="items?.length > 0" :head="tableHead" list-view="mdAndUp">
    <template v-for="(item, key) in items">
      <PremiumTableItems :key="key" :item="item" :edit="edit" />
    </template>
  </BaseTableView>
  <Plug v-else />
</template>

<script>
import PremiumTableItems from './PremiumTableItems.vue'
import Plug from 'components/Plug.vue'

export default {
  name: 'PremiumTable',
  props: {
    items: [Array, Object],
    edit: Boolean,
  },
  components: { Plug, PremiumTableItems },
  computed: {
    translation() {
      return this.localStorage.translations.pages['setting-personal_area'].labels
    },
    tableHead() {
      return [
        { text: this.translation['personal_premium'] },
        { text: this.translation.primechanie },
        { text: this.translation['changed_by'] },
        { text: this.localStorage.translations.pages.finance['period-table'].date },
      ]
    },
  },
}
</script>

<style scoped lang="scss">
:deep() tbody {
  tr {
    td {
      width: 200px;
      &:first-of-type{
        width: 250px;
      }
    }
  }
}
</style>
